import MainLayout from "screens/partials/layout";
import StorboltProductListingComponent from "screens/partials/product-listing";

export default function ProductList() {
    return (
        <MainLayout>
            <StorboltProductListingComponent/>
        </MainLayout>
    )
}